import type { ViewerEnvelope } from './apiClientResponses';

export type CanonicalAuthenticatedSession = ViewerEnvelope & {
	viewer: ViewerEnvelope['viewer'] & {
		authStatus: 'authenticated';
		userId: string;
		sessionHash: string;
	};
};

/**
 * A logged-in UI may only be committed from the server's complete session
 * identity. userId scopes user data; sessionHash separates concurrent device
 * sessions and is required by billing, entitlement, cache, and media flows.
 */
export function parseCanonicalAuthenticatedSession(value: unknown): CanonicalAuthenticatedSession | null {
	if (!value || typeof value !== 'object') return null;
	const viewer = (value as { viewer?: unknown }).viewer;
	if (!viewer || typeof viewer !== 'object') return null;
	const candidate = viewer as { authStatus?: unknown; userId?: unknown; sessionHash?: unknown };
	if (candidate.authStatus !== 'authenticated') return null;
	if (typeof candidate.userId !== 'string' || !candidate.userId.trim()) return null;
	if (typeof candidate.sessionHash !== 'string' || !candidate.sessionHash.trim()) return null;
	return value as CanonicalAuthenticatedSession;
}
